export const SoulodyClientPlugin = {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$soulodyApi', {
      get() {
        return this.$store?.$soulodyApi;
      }
    });
  }
};
